import type {
  AllergyId,
  DietId,
  ExerciseId,
  FamilyHistoryConditionId,
  LifestyleFactorId,
  MedicalConditionId,
  OutcomeId,
  ScreeningId,
  SleepHabitId,
  SymptomId,
} from "@/lib/questionnaire/options";
import type {
  FamilyMedicalHistory,
  MedicationEntry,
} from "@/lib/questionnaire/schema";
import {
  FAMILY_HISTORY_CONDITIONS,
  FAMILY_HISTORY_RELATIONS,
} from "@/lib/questionnaire/options";

function emptyFamilyHistoryRelationFlags() {
  return Object.fromEntries(
    FAMILY_HISTORY_RELATIONS.map((relation) => [relation.id, false]),
  ) as FamilyMedicalHistory[FamilyHistoryConditionId];
}

function createEmptyFamilyMedicalHistory(): FamilyMedicalHistory {
  return Object.fromEntries(
    FAMILY_HISTORY_CONDITIONS.map((condition) => [
      condition.id,
      emptyFamilyHistoryRelationFlags(),
    ]),
  ) as FamilyMedicalHistory;
}

export const defaultQuestionnaireValues = {
  firstName: "",
  lastName: "",
  dateOfBirth: undefined as Date | undefined,
  email: "",
  phone: "",
  privacyAgreed: false as boolean,
  selectedSymptoms: [] as SymptomId[],
  additionalSymptoms: "",
  selectedOutcomes: [] as OutcomeId[],
  additionalOutcomes: "",
  selectedAllergies: [] as AllergyId[],
  additionalAllergies: "",
  selectedMedicalConditions: [] as MedicalConditionId[],
  additionalMedicalConditions: "",
  familyMedicalHistory: createEmptyFamilyMedicalHistory(),
  currentWeight: undefined as number | undefined,
  heightFeet: undefined as number | undefined,
  heightInches: undefined as number | undefined,
  selectedDiets: [] as DietId[],
  additionalDiet: "",
  selectedExercise: [] as ExerciseId[],
  additionalExercise: "",
  selectedSleepHabits: [] as SleepHabitId[],
  additionalSleepHabits: "",
  selectedLifestyleFactors: [] as LifestyleFactorId[],
  additionalLifestyleFactors: "",
  currentSupplements: [] as string[],
  currentMedications: [] as MedicationEntry[],
  selectedScreening: [] as ScreeningId[],
  additionalScreening: "",
};

export type QuestionnaireFormValues = typeof defaultQuestionnaireValues;
